export default __webpack_public_path__ + "static/media/A12.c8aebaa1.png";